<template>
  <div class="car-restriction">
    <div class="row">
      <div class="col-sm-4">
        <h4>{{ carRestriction.name }}</h4>
        <p>
          <strong>Vehicle: </strong>
          <router-link :to="'/fleet/vehicles/' + carRestriction.Car.uuid">
            {{ carRestriction.Car.dropdownLabel }}
          </router-link>
        </p>
        <p class="alert alert-info" v-if="carRestriction.allDates">
          Restriction Applies every week of the year
        </p>
        <p v-else>
          <strong>Start Date: </strong>
          {{ carRestriction.startDate | date_format }}<br/>
          <strong>End Date: </strong>
          {{ carRestriction.endDate | date_format }}
        </p>
        <p class="alert alert-info" v-if="carRestriction.allTimes">
          Restriction Applies 24 hours a day
        </p>
        <p v-else>
          <strong>Start Time: </strong>
          {{ carRestriction.startTime | time_format }}<br/>
          <strong>End Time: </strong>
          {{ carRestriction.endTime | time_format }}
        </p>
      </div>
      <div class="col-sm-4">
        <h4>Days Restriction Applies</h4>
        <p>
          <strong>Sunday: </strong>
          <span class="fa" :class="{
            'text-danger fa-times': !carRestriction.dayRange.sunday,
            'text-success fa-check': carRestriction.dayRange.sunday
          }"></span>
        </p>
        <p>
          <strong>Monday: </strong>
          <span class="fa" :class="{
            'text-danger fa-times': !carRestriction.dayRange.monday,
            'text-success fa-check': carRestriction.dayRange.monday
          }"></span>
        </p>
        <p>
          <strong>Tuesday: </strong>
          <span class="fa" :class="{
            'text-danger fa-times': !carRestriction.dayRange.tuesday,
            'text-success fa-check': carRestriction.dayRange.tuesday
          }"></span>
        </p>
        <p>
          <strong>Wednesday: </strong>
          <span class="fa" :class="{
            'text-danger fa-times': !carRestriction.dayRange.wednesday,
            'text-success fa-check': carRestriction.dayRange.wednesday
          }"></span>
        </p>
        <p>
          <strong>Thursday: </strong>
          <span class="fa" :class="{
            'text-danger fa-times': !carRestriction.dayRange.thursday,
            'text-success fa-check': carRestriction.dayRange.thursday
          }"></span>
        </p>
        <p>
          <strong>Friday: </strong>
          <span class="fa" :class="{
            'text-danger fa-times': !carRestriction.dayRange.friday,
            'text-success fa-check': carRestriction.dayRange.friday
          }"></span>
        </p>
        <p>
          <strong>Saturday: </strong>
          <span class="fa" :class="{
            'text-danger fa-times': !carRestriction.dayRange.saturday,
            'text-success fa-check': carRestriction.dayRange.saturday
          }"></span>
        </p>
      </div>
      <div class="col-sm-4">
        <template v-if="carRestriction.Accounts.length > 0">
          <h4>Accounts with Access</h4>
          <p v-for="account in carRestriction.Accounts">
            <a :to="`/membership/members/${account.uuid}`">
              {{ account.dropdownLabel }}
            </a>
          </p>
        </template>
        <template v-if="carRestriction.AccountTypes.length > 0">
          <h4>Account Types with Access</h4>
          <p v-for="accountType in carRestriction.AccountTypes">
            <a :to="`/membership/plans/${accountType.uuid}`">
              {{ accountType.name }}
            </a>
          </p>
        </template>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link class="btn btn-default" :to="'/fleet/restrictions/edit/' + carRestriction.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button class="btn btn-danger" @click="deleteRestriction(carRestriction)">
        <span class="fa fa-trash-alt fa-fw"></span> Delete
      </button>
    </div>
  </div>
</template>

<script>
import {
  DELETE_CAR_RESTRICTION
} from '@/vuex/types'
import { mapActions } from 'vuex'
export default {
  name: 'CarRestriction',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    carRestriction () {
      return {
        Car: {},
        Accounts: [],
        AccountTypes: [],
        dayRange: {},
        ...this.object
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    async executeAction (action, payload) {
      await this[action](payload)
    },
    deleteRestriction (restriction) {
      this.executeAction(DELETE_CAR_RESTRICTION, restriction)
    },
    ...mapActions([
      DELETE_CAR_RESTRICTION
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/CarRestriction.vue